// @flow

import React from 'react';

const AccountDelete = ({ translate } : { translate: any }) => (
  <div className="del-block">
    <h2>
      {translate('settings.want_delete')}
    </h2>
    <p>
      <em>
        {translate('settings.delete_information')}
      </em>
    </p>
    <a data-toggle="modal" data-target="#delete-acount-modal" className="del-link">
      {translate('settings.yes_delete')}
    </a>
  </div>
);

export default AccountDelete;



// WEBPACK FOOTER //
// ./src/components/main/settings/accountDelete.js